import { Box, Button, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import { useTheme } from "../../../../../../context/themeContext";
import useDiscover from "../../../../../../hooks/useDiscover";
import useManageProjects from "../../../../../../hooks/useManageProjects";
import Image from "./image";
import styles from "./style.module.css";
import Top from "./top";
import axios from "axios";
import { node_server } from "../../../../../../constants";

const ProjectCard = ({ project }) => {
	const { theme, darkMode } = useTheme();
	const navigate = useNavigate();
	const [isFavorite, setIsFavorite] = useState(project.is_favourite);
	const [showConfetti, setShowConfetti] = useState(false);
	const [liking, setLiking] = useState(null);

	const { handleSwipeLeft, handleSwipeRight } = useDiscover(true);
	const { removing, projectFavorites } = useSelector(
		(state) => state.discover,
	);

	const { handleFavorite } = useManageProjects();

	const handleClick = () => {
		setShowConfetti(true);
	};

	const addToFavorite = async (id) => {
		setLiking(project);
		setIsFavorite(true);
		setTimeout(() => {
			if (project.is_favourite === false) {
				handleFavorite(id, "add");
			}
			handleClick();
			setLiking(null);
		}, 100);

		if (project.is_favourite === false) {
			const response = await axios.post(
				`${node_server}/api/project-feed/${project.project_id}`,
				{
					is_favourite: true,
				},
				{
					withCredentials: true,
				},
			);
			if (response.status !== 200) {
				console.error("Error updating project feed:", response.data);
			}
		}
	};

	const handlers = useSwipeable({
		onSwipedRight: () => {
			handleSwipeLeft(project);
			addToFavorite(project.project_id);
		},
		onSwipedLeft: () => handleSwipeRight(project),
	});

	useEffect(() => {
		let fav;
		projectFavorites.map((item) => {
			item.project_id === project.project_id
				? (fav = true)
				: (fav = project.is_favourite);
		});
		setIsFavorite(fav);
	}, [project]);

	return (
		<Box
			{...handlers}
			className={`${styles.card} ${
				removing === project ? styles.removing : ""
			} ${liking === project ? styles.liking : ""}`}
			sx={{
				bgcolor: darkMode
					? theme.palette.lightgrey.lightgrey400
					: "#FFF",
			}}
		>
			<Top
				project={project}
				isFavorite={isFavorite}
				setIsFavorite={setIsFavorite}
				showConfetti={showConfetti}
				setShowConfetti={setShowConfetti}
				addToFavorite={addToFavorite}
			/>
			<Divider sx={{ width: "100%" }} />
			<Box className={styles.content}>
				<Image image={project.project_cover_image} />
				<Box className={styles.text}>
					<Typography
						component="h4"
						variant="body1"
						sx={{
							fontSize: "20px",
							fontWeight: "500",
							color: theme.palette.darkgrey.darkgrey600,
							overflow: "hidden",
							WebkitLineClamp: 1,
							minHeight: "1.5em",
							width: "100%",
						}}
					>
						{project?.project_title}
					</Typography>
				</Box>
			</Box>
			<Divider sx={{ width: "100%" }} />
			<Box className={styles.button}>
				<Button
					variant="contained"
					onClick={() => navigate(`/projects/${project?.project_id}`)}
					sx={{
						textTransform: "capitalize",
						flex: "1",
						p: "10px 1.5rem",
						borderRadius: "4px",
					}}
				>
					View Project
				</Button>
			</Box>
		</Box>
	);
};

export default ProjectCard;
